// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { CardBlurType } from './CardBlur';
import styled from 'styled-components';

export const Card = styled.div<CardBlurType>`
  width: ${(props) => (props.fullWidth ? '100%' : 'fit-content')};
  height: ${(props) => (props.fullWidth ? '100%' : 'fit-content')};
  border: 1.2px solid #343434;
  background-color: ${(props) =>
    props.bgColor ? props.bgColor : 'rgb(13 13 14 / 50%)'};
  backdrop-filter: ${(props) =>
    props.blur ? `blur(${props.blur}px)` : 'blur(75px)'};
  border-radius: ${(props) =>
    props.borderRadius ? `${props.borderRadius}px` : '10px'};
  box-shadow: ${(props) =>
    props.shadow ? props.shadow : '0 0 0 0 rgb(0 0 0 / 0%)'};
  border-color: ${(props) =>
    props.borderColor ? props.borderColor : '#343434'};
  overflow: hidden;
  box-sizing: border-box;
`;
